<template>
    <ModalWithButton
        :name="modalName"
        title="Añadir evento y sesión"
        button_title="Añadir evento y sesión"
        @cerrar="cerrar()"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="evento" rules="required" v-slot="{ errors }">
                        <label for="provincias">Seleccionar evento</label>
                        <multiselect
                            v-model="data.evento"
                            placeholder="Evento"
                            label="name"
                            track-by="id"
                            :options="eventos"
                            :max-height="130"
                            :multiple="false"
                        />
                        <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
                <b-col v-if="data.evento" cols="12" class="mt-3">
                    <ValidationProvider name="sesion" rules="required" v-slot="{ errors }">
                        <label for="provincias">Seleccionar sesión</label>
                        <multiselect
                            v-model="data.sesion"
                            placeholder="Sesión"
                            label="date"
                            track-by="id"
                            :options="data.evento.sesiones"
                            :max-height="130"
                            :multiple="false"
                        />
                        <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
                <div class="col-12 text-right mt-3">
                    <Button type="submit" name="button">CONTINUAR</Button>
                </div>
            </b-row>
        </ValidationObserver>
    </ModalWithButton>
</template>

<script>
import ModalWithButton from '../../components/ModalWithButton.vue';

export default {
    props: {
        pack_id: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            data: {},
            modalName: 'add-event',
            eventos: []
        }
    },
    created() {
        this.getEventosDisponibles();
    },
    methods: {
        getEventosDisponibles(){
            this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.eventos.disponibles'), { filters: {}, pack_id: this.pack_id}).then(res => {
                this.eventos = res.data.data;
            });
        },
        addEvent() {
            let data = {
                filters: {},
                pack_id: this.pack_id,
                event_id: this.data.evento.id,
                sesion_id: this.data.sesion.id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.eventos.add'), data).then(res => {
                this.$emit('actualizar');
                this.cerrar();
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.addEvent();
            }
        },
        cerrar() {
            this.$modal.hide(this.modalName);
            this.data = {};
            this.getEventosDisponibles();
        }
    },
    components: {
        ModalWithButton
    }
}
</script>
